<template>
  <div id="overlay">
    <div id="lef">
      <img id="leftImage" alt="暂无图片" v-bind:src="img1Src" />
    </div>
    <div id="rit">
      <img id="topImage" alt="暂无图片" v-bind:src="img2Src" />
      <label id="overlayName">{{ overlayName }}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CunstomOverlay',
  props: {
    overlayName: {
      type: String,
      default: 'name'
    },
    img1Src: {
      type: String,
      default: '@/src/assets/logo.png'
    },
    img2Src: {
      type: String,
      default: '@/src/assets/logo.png'
    }
  }
}
</script>

<style scoped>
#overlay {
  position: absolute;
  width: 100px;
  height: 100px;
}
#rit {
  position: absolute;
  right: 0px;
  width: 50%;
  height: 100%;
}
#lef {
  position: absolute;
  right:50%;
  bottom: 30%;
  height: 20%;
  width: 20%;
}
#topImage {
  position: absolute;
  right: 0%;
  height: 50%;
  width: 100%;
}

#leftImage {
  height: 100%;
  width: 100%;
}
#overlayName {
  position: absolute;
  top: 50%;
  width: 100%;
  color: black;
  background: white;
}
</style>
